import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from '@app/modules/table/table.module';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
import { Components } from '@time-tracking/components';
import { Guards } from '@time-tracking/guards';
import { Services } from '@time-tracking/services';
import { Views } from '@time-tracking/views';
import { Directives } from './directives';
import { TimeTrackingResolver } from './time-tracking.resolver';
import { TimeTrackingRouterModule } from './time-tracking.routes';

@NgModule({
    imports: [
        TimeTrackingRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        PlatformModule,
        TableModule,
    ],
    declarations: [...Views, ...Components, ...Directives],
    providers: [...Services, TimeTrackingResolver, ...Guards],
})
export class TimeTrackingModule {}
